import React, { useCallback } from 'react'
import { Dialog, DialogTitle, IconButton, CircularProgress } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { gray } from '../../../utils/colors'
import BackButton from '../../Button/BackButton'

const useStyles = makeStyles(() => ({
	header: {
		display: 'flex',
		alignItems: 'center',
		padding: '1.1rem 1.5rem',
		'& .MuiIconButton-root': {
			'& .MuiIconButton-label': {
				'& svg': {
					fill: gray[700]
				}
			}
		}
	},
	headerContainer: {
		display: 'flex',
		flex: 1,
		gap: '1rem'
	},
	activityOverlay: {
		position: 'absolute',
		zIndex: 20000,
		backgroundColor: 'rgba(255,255,255,.8)',
		width: '100%',
		height: '100%',
		display: 'flex',
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center'
	}
}))

const StyledDialog = ({
	open,
	onClose,
	title = 'Dialog',
	children,
	showActivityIndicator = false,
	titleActions = null,
	showBackButton = false,
	onBackButtonPressed,
	width = 920,
	maxWidth = 920,
	minHeight = '80%',
	minWidth = 920
}) => {
	const classes = useStyles()

	const handleOnBackButtonPressed = useCallback(() => {
		if (onBackButtonPressed) {
			onBackButtonPressed()
		}
	}, [onBackButtonPressed])

	const handleOnClose = useCallback(() => {
		if (onClose) {
			onClose()
		}
	}, [onClose])

	return (
		<Dialog
			open={open}
			onClose={handleOnClose}
			PaperProps={{
				style: {
					width,
					maxWidth,
					minHeight,
					minWidth,
					padding: 0
				}
			}}>
			<DialogTitle>
				<div className={classes.header}>
					<div className={classes.headerContainer}>
						{showBackButton ? <BackButton onClicked={handleOnBackButtonPressed} /> : null}
						<div>{title}</div>
					</div>
					{titleActions ? titleActions : null}
					{onClose ? (
						<IconButton onClick={handleOnClose} disableRipple style={{ padding: 0, flex: 0 }}>
							<Close />
						</IconButton>
					) : null}
				</div>
			</DialogTitle>
			{showActivityIndicator ? (
				<div className={classes.activityOverlay}>
					<CircularProgress />
				</div>
			) : null}
			{children}
		</Dialog>
	)
}

export default StyledDialog
